import { CentricPoItemVariant } from "./centric-po-item-variant";

export class CentricPoItemDetails {

    poLine: string;
    material: string;
    color: string;
    gender: string;
    shortDescription:string;
    packMethod:string;
    vendorBookingFlag:string;

    ppkupc:string;
    currency:string;
    totalQuantity:string;
    style:string;
    poType:string;

    // materialNo: string;
    // poItem: string;
    // season: string;
    // incoterms: string;
    // contractualDeliveryDate: string;
    // inboundPkg: string;
    // incotermsPlace: string;
    // handoverDate: string;
    // mfgProcess: string;
    // harbor: string;
    // shipMode: string;
    // model: string;
    // productType: string;
    // merchDivision: string;
    // colorDescription: string;
    // class: string;
    // conceptShortDesc: string;
    // fabricContent: string;
    // board: string;
    // fishWildlifeInd: string;
    // gender: string;
    // downFeatherInd: string;
    // fabrication: string;
    CentricpoItemVariantDetails: CentricPoItemVariant[]

}